import React, { Component } from 'react';
import { connect } from 'react-redux';

import Icon from '../../../../components/Icon';
import SidePanel from '../../../../components/SidePanel';
import Tabs from '../../../../components/Tabs';
import Tab from '../../../../components/Tabs/Tab';
import { AlertBox } from '../../../../components/AlertBox';

import Tracking from './Tracking';
import History from './History';
import Occurrences from './Occurrences';
import Receipts from './Receipts';
import { getCurrentNFDetails } from '../../../../redux/selectors';

import { S } from './styles';
import './styles.css';
import Volume from './Volume';
import { isEmptyString } from '../../../../utils/validators';

// consts

export const detailsTabs = {
  TRACKING: 'tracking',
  FORECAST_HISTORY: 'forecast_history',
  VOLUME: 'volume',
  OCCURRENCES: 'occurrences',
  RECEIPTS: 'receipts',
};

// component

class TrackingDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTab: detailsTabs.TRACKING,
    };
  }

  componentDidMount() {
    const { openOccurenceTab, openReceiptTab } = this.props;

    if (openOccurenceTab) {
      this._changeToOccurrence();
    }

    if (openReceiptTab) {
      this._changeToReceipt();
    }
  }

  _changeTab = (currentTab) => {
    this.setState({ currentTab });
  };

  _changeToOccurrence = () => {
    this._changeTab(detailsTabs.OCCURRENCES);
  };

  _changeToReceipt = () => {
    this._changeTab(detailsTabs.RECEIPTS);
  };

  _renderContent = () => {
    const { currentTab } = this.state;
    const { 
      onTrackingManager,
      showTrackingManager,
      showTable,
      showNewForm,
      setShowTable,
      setShowNewForm } = this.props;

    if (currentTab === detailsTabs.TRACKING) {
      return <Tracking 
        onTrackingManager={onTrackingManager}
        showTrackingManager={showTrackingManager}
        showTable={showTable}
        showNewForm={showNewForm}
        setShowTable={setShowTable}
        setShowNewForm={setShowNewForm} 
        data={this.props.nfData} 
      />;
    }

    if (currentTab === detailsTabs.FORECAST_HISTORY) {
      return <History nfData={this.props.nfData} />;
    }

    if (currentTab === detailsTabs.OCCURRENCES) {
      return <Occurrences nfData={this.props.nfData} />;
    }

    if(currentTab === detailsTabs.VOLUME) {
      return <Volume nfData={this.props.nfData} />;
    }

    return <Receipts nfData={this.props.nfData} />;
  };

  render() {
    const { onDismiss, nfData } = this.props;
    const { currentTab } = this.state;

    const { nf, nfGroup, order } = nfData;
    return (
      <SidePanel onDismiss={onDismiss}>
        <div className="TrackingDetails">
          <S.TrackingDetailsHeader>
            <S.TrackingDetailsToolbar>
              <Icon
                className="TrackingDetails__close-modal-mobile"
                name="close"
                onClick={onDismiss}
              />
              <S.HeaderInfoContainer>
                <h3>Detalhes da nota</h3>
                <S.HeaderInfoWrapper>
                  <S.HeaderOrderInfo>
                    <S.InfoText title>NF</S.InfoText>
                    <S.InfoText>{nf} {nfGroup ? `-${nfGroup}` : ''}</S.InfoText>
                  </S.HeaderOrderInfo>
                  <S.HeaderOrderInfo>
                    <S.InfoText title>Pedido</S.InfoText>
                    <S.InfoText>{order || 'N/A'}</S.InfoText>
                  </S.HeaderOrderInfo>
                </S.HeaderInfoWrapper>
              </S.HeaderInfoContainer>
            </S.TrackingDetailsToolbar>
          </S.TrackingDetailsHeader>
          <Tabs className="TrackingDetails__tabs">
            <Tab
              className="TrackingDetails__tab"
              onClick={() => {
                this._changeTab(detailsTabs.TRACKING);
              }}
              isActive={currentTab === detailsTabs.TRACKING}
            >
              Acompanhamento
            </Tab>
            <Tab
              className="TrackingDetails__tab"
              onClick={() => {
                this._changeTab(detailsTabs.FORECAST_HISTORY);
              }}
              isActive={currentTab === detailsTabs.FORECAST_HISTORY}
            >
              Histórico de Previsão
            </Tab>
            <Tab
              className="TrackingDetails__tab"
              onClick={() => {
                this._changeTab(detailsTabs.VOLUME);
              }}
              isActive={currentTab === detailsTabs.VOLUME}
            >
              Lista de volumes
            </Tab>
            <Tab
              className="TrackingDetails__tab"
              onClick={() => {
                this._changeTab(detailsTabs.OCCURRENCES);
              }}
              isActive={currentTab === detailsTabs.OCCURRENCES}
            >
              Ocorrências
            </Tab>
            <Tab
              className="TrackingDetails__tab"
              onClick={() => {
                this._changeTab(detailsTabs.RECEIPTS);
              }}
              isActive={currentTab === detailsTabs.RECEIPTS}
            >
              Fotos e Comprovantes
            </Tab>
          </Tabs>
          {
            !nfData?.cnpjDest || nfData?.cnpjDest.length === 0 || isEmptyString(nfData?.cnpjDest) ? 
            <AlertBox
              title="Nota fiscal inserida manualmente pelo motorista"
              description="Para obter mais informações e validar os dados, inclua o arquivo XML desta nova via por meio do serviço disponível."
              iconName="warning"
              type="warning"
            /> : null
          }
          
          {this._renderContent()}
        </div>
      </SidePanel>
    );
  }
}

function mapStateToProps(state) {
  return {
    nfData: getCurrentNFDetails(state),
  };
}

export default connect(mapStateToProps)(TrackingDetails);
